export default __webpack_public_path__ + "74a9a1a75a19d977cdaae11d7f7fcc76.jpg";